import { Box } from "@chakra-ui/react";
import { FC } from "react";

import {
  FeatureCard,
  FeatureGrid,
  PageCta,
  PageHero,
  PageSection,
  SectionHeading,
  usePageTitle,
} from "./components";

export const VoorDrinkwaterbedrijven: FC = () => {
  usePageTitle("BROSTAR voor Drinkwaterbedrijven");

  return (
    <Box>
      <PageHero
        title="BROSTAR voor Drinkwaterbedrijven"
        subtitle="Volgens de wet zijn sinds 3 maart 2025 drinkwaterbedrijven ook bronhouder. Hiermee zijn zij verantwoordelijk voor het aanleveren van grondwaterdata aan de Basisregistratie Ondergrond. BROSTAR helpt drinkwaterbedrijven bij het betrouwbaar en efficiënt aanleveren van deze data."
      />

      <PageSection>
        <SectionHeading>Specifiek voor drinkwaterbronhouders</SectionHeading>
        Er gelden andere regels voor drinkwaterbedrijven dan voor de overheidsinstanties. Zowel in
        de regelgeving, als in de praktijk. Drinkwaterbedrijven meten vanwege andere redenen, en met
        een andere intensiteit dan bijvoorbeeld gemeenten. Het monitoren van het drinkwater is een
        primaire taak voor hun, en dit betekend dat zij een grote hoeveelheid grondwatergegevens ter
        beschikking hebben, die voor veel andere waardevol is. Deze hoeveelheid data maakt ook het
        proces complex, en de rijke geschiedenis van sommige drinkwaterbedrijven maakt de
        organisatie van gegevens alleen maar complexer. BROSTAR biedt een modulaire oplossing voor
        de levering richting de BRO, en is in staat om met meerdere beheersystemen samen te werken.
        Bij Nelen & Schuurmans hebben we veel ervaring met het inrichten van dit soort systemen, en
        we denken dus graag mee over de beste manier om dit in te richten.
        <FeatureGrid>
          <FeatureCard title="In de praktijk: Vitens">
            Vitens gebruikt BROSTAR om geautomatiseerd aan al haar verplichtingen te voldoen:
            peilbuizen, meetnetten, grondwaterstanden en zoutwachtergegevens (GMW, GMN, GLD en FRD)
            worden aangeleverd aan de BRO. Hierbij versturen we meer dan 100.000 berichten per jaar.
            Validatie gebeurt in Lizard, via ArtDiver.
          </FeatureCard>
          <FeatureCard title="Winning- en monitoringsputten">
            Registreer al uw grondwaterwinningsputten (GMW) en monitoringsputten correct in de BRO.
            Ook wanneer uw gegevens niet allemaal publiek beschikbaar mogen zijn, is dit geen
            probleem. In BROSTAR kunt u dit zelf aangeven.
          </FeatureCard>
          <FeatureCard title="Grondwaterkwaliteitsmetingen">
            Hoewel drinkwaterbedrijven nog niet aan de lat staan voor de levering van
            kwaliteitsmetingen, is het mogelijk om dit op eenvoudige wijze via BROSTAR toch te doen.
            Exporteer de gegevens uit het laboratorium en zet het om naar ons Sjabloon, waarna u het
            eenvoudig kunt uploaden. Zo draagt u bij aan een vollediger beeld van de ondergrond.
          </FeatureCard>
          <FeatureCard title="Tijdreeksen grondwaterstand">
            Met grondwaterstanden houden wij ons veel bezig. In samenwerking met Artesia zijn we tot
            een oplossing gekomen waarbij registraties van voorlopig, volledigBeoordeelde en
            controle metingen feilloos kunnen worden aangeleverd, inclusief correcties wanneer deze
            vanuit ArtDiver worden doorgevoerd.
          </FeatureCard>
          <FeatureCard title="Eenvoudig in te zetten">
            Hoewel het mogelijk is een automatische koppeling te bouwen, is het altijd mogelijk om
            BROSTAR voor een deel van uw verantwoordelijkheden in te zetten. Zo kan het zijn dat uw
            leverancier niet in staat is correcties of verwijder berichten te sturen, met BROSTAR
            heeft u zelf altijd een laagdrempelige manier om dit soort berichten te versturen,
            zonder dat u hiervoor een koppeling hoeft te bouwen.
          </FeatureCard>
          <FeatureCard title="Eenvoudig te leren">
            BROSTAR heeft een beperkte set aan functionaliteiten, en hierdoor is het ook eenvoudig
            om te leren. Nieuwe medewerkers kunnen zonder veel moeite aan de slag, en na enkele
            keren de applicatie gebruikt te hebben zullen ze er al snel wegwijs in zijn. Daarnaast
            is onze servicedesk altijd beschikbaar om vragen te beantwoorden, en kunnen we ook
            trainingen verzorgen wanneer hier behoefte aan is.
          </FeatureCard>
          <FeatureCard title="Gedeelde oplossing, voor langdurige samenwerking">
            Meerdere organisaties geloven in BROSTAR, hierdoor is de levensduur van de applicatie
            gewaarborgd. We blijven continu doorontwikkelen, en staan altijd open voor feedback en
            suggesties.
          </FeatureCard>
        </FeatureGrid>
      </PageSection>

      <PageCta
        title="BRO-aanlevering voor drinkwaterbedrijven"
        body="Ontdek hoe BROSTAR drinkwaterbedrijven helpt bij betrouwbare en efficiënte BRO-aanlevering."
      />
    </Box>
  );
};
